import type { KpiEntry } from "@/api/kpi";

/**
 * Kritik stok — `/api/v2/kpi/kritik_stok/items` VARYANT bazli ham satirlar
 * doner (bkz. app/core/kpi/loaders.py `load_stock`: her satir tek bir
 * beden/renk kombinasyonu). docs/faz5-arayuz-spec.md §5: "kritik_stok
 * satırları varyant bazlı gelir — client-side ürün kartına gruplama".
 * Gruplama anahtari `product_card_id` (yoksa urun adi).
 */
export interface StockProductGroup {
  productCardId: string;
  name: string;
  category: string;
  supplier: string;
  variants: KpiEntry[];
  totalStock: number;
  minStock: number;
}

export function groupStockByProduct(rows: KpiEntry[]): StockProductGroup[] {
  const groups = new Map<string, StockProductGroup>();
  for (const row of rows) {
    const key = String(row.product_card_id ?? row.name ?? "—");
    let group = groups.get(key);
    if (!group) {
      group = {
        productCardId: key,
        name: String(row.name ?? "—"),
        category: String(row.category ?? ""),
        supplier: String(row.supplier ?? ""),
        variants: [],
        totalStock: 0,
        minStock: Number.POSITIVE_INFINITY,
      };
      groups.set(key, group);
    }
    const stock = Number(row.stock) || 0;
    group.variants.push(row);
    group.totalStock += stock;
    group.minStock = Math.min(group.minStock, stock);
  }
  // En kritik (en dusuk minimum stoklu) urun karti en ustte.
  return Array.from(groups.values()).sort((a, b) => a.minStock - b.minStock);
}
